import { Component, Input } from '@angular/core';
import { ApplicationRoles, PagedResponse, PortalService, SessionService } from '@edl-development/edl-common';
import { EdlPortalToken } from '@edl-development/edl-common/lib/models/edl-portal-token.model';
import { StateService, Transition } from '@uirouter/core';
import { first } from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { EdlRegistrationToken } from 'src/app/model/edl-registration-token.model';
import { AccessRoleHelper } from 'src/app/model/helpers/access-role.helper';

@Component({
  selector: 'edl-token-admin-list',
  templateUrl: './token-admin-list.component.html',
  styleUrls: ['./token-admin-list.component.scss']
})
export class TokenAdminListComponent {

  @Input() tokens?: PagedResponse<EdlPortalToken>;

  constructor(

      private sessionService: SessionService,
      private transition: Transition,
      private stateService: StateService,
      private portalService: PortalService,
      private toastrService: ToastrService
  ) { }

  ngOnInit() {}

  ApplicationRoles = ApplicationRoles;
  AccessRoleHelper = AccessRoleHelper;
  busy: boolean = false;


  deleteToken(token:any){
    this.portalService.deletePortalToken(token).subscribe((response) => {
      this.toastrService.success('Token deleted successfully.');
      this.stateService.reload();
    });
  }

  setAsDefault(token: EdlPortalToken) {
    firstValueFrom(this.portalService.setDefaultPortalToken(token.Token))
      .then(() => {
        this.toastrService.success('Default token set successfully.');
        this.stateService.reload();
      });
  }
}
